type PressFontSize =
  | 'fs10'
  | 'fs13'
  | 'fs16'
  | 'fs18'
  | 'fs20'
  | 'fs24'
  | 'fs31'
  | 'fs39'
  | 'fs49'
  | 'fs61'
  | 'fs71'
  | 'fs95'
  | 'fs104'
  | 'fs119';

type PressFontSizeAliases = Record<PressFontSize, number>;

export type PressFontSizes = number[] & Partial<PressFontSizeAliases>;

const pressFontSizes: PressFontSizes = [
  10.2,
  13,
  16,
  18,
  20,
  24,
  31.3,
  39.1,
  48.8,
  61,
  71,
  95.4,
  104,
  119.2
];

export const pressFontSizeAliases: PressFontSizeAliases = {
  fs10: pressFontSizes[0],
  fs13: pressFontSizes[1],
  fs16: pressFontSizes[2],
  fs18: pressFontSizes[3],
  fs20: pressFontSizes[4],
  fs24: pressFontSizes[5],
  fs31: pressFontSizes[6],
  fs39: pressFontSizes[7],
  fs49: pressFontSizes[8],
  fs61: pressFontSizes[9],
  fs71: pressFontSizes[10],
  fs95: pressFontSizes[11],
  fs104: pressFontSizes[12],
  fs119: pressFontSizes[13]
};

Object.keys(pressFontSizeAliases).forEach(pressFontSize => {
  const pressFontSizeKey = pressFontSize as PressFontSize;
  pressFontSizes[pressFontSizeKey] = pressFontSizeAliases[pressFontSizeKey];
});

export default pressFontSizes;
